/**
 * The maturity status of a feature
 */
export enum FeatureStatus {
  Beta = 'BETA',
  Alpha = 'ALPHA',
  GeneralAvailability = 'GENERAL_AVAILABILITY',
}

/**
 * The type of value a feature can have
 */
export enum FeatureType {
  Boolean = 'BOOLEAN',
  FeatureGate = 'FEATURE_GATE',
  Number = 'NUMBER',
  StringList = 'STRING_LIST',
  SupportTier = 'SUPPORT_TIER',
}

/**
 * Names of features in the database
 */
export enum FeatureDefinitionName {
  AllowPrivateDockerRegistryAccess = 'ALLOW_PRIVATE_DOCKER_REGISTRY_ACCESS',
  WhiteLabelPrivacyRequestEmails = 'WHITE_LABEL_PRIVACY_REQUEST_EMAILS',
  WhiteLabelPrivacyCenter = 'WHITE_LABEL_PRIVACY_CENTER',
  DisabledPrivacyCenterAboutTranscend = 'DISABLED_PRIVACY_CENTER_ABOUT_TRANSCEND',
  IsSandbox = 'IS_SANDBOX',
  Assessments = 'ASSESSMENTS',
  Prompts = 'PROMPTS',
  SelfHostedSombra = 'SELF_HOSTED_SOMBRA',
  PrivacyCenter = 'PRIVACY_CENTER',
  SupportTier = 'SUPPORT_TIER',
  AuditorMonthlyUsageLimit = 'AUDITOR_MONTHLY_USAGE_LIMIT',
  TranscendHostedPromptManagerMonthlyUsageLimit = 'TRANSCEND_HOSTED_PROMPT_MANAGER_MONTHLY_USAGE_LIMIT',
  DataLineage = 'DATA_LINEAGE',
  SiloDiscovery = 'SILO_DISCOVERY',
  WorkflowsV2 = 'WORKFLOWS_V2',
  StructuredDataDiscovery = 'STRUCTURED_DATA_DISCOVERY',
  UnstructuredDataDiscovery = 'UNSTRUCTURED_DATA_DISCOVERY',
  DsrAutomation = 'DSR_AUTOMATION',
  PreferenceStore = 'PREFERENCE_STORE',
  WebConsent = 'WEB_CONSENT',
  ActionItemChecklists = 'ACTION_ITEM_CHECKLISTS',
  MobileConsentApps = 'MOBILE_CONSENT_APPS',
  ContractScanning = 'CONTRACT_SCANNING',
  Pathfinder = 'PATHFINDER',
  LlmClassifier = 'LLM_CLASSIFIER',
  LlmUnstructured = 'LLM_UNSTRUCTURED',
  AirgapAllowedVersionTags = 'AIRGAP_ALLOWED_VERSION_TAGS',
  MaxSyncDomainCount = 'MAX_SYNC_DOMAIN_COUNT',
  CustomDomainUI = 'CUSTOM_DOMAIN_UI',
  ConsentWorkflows = 'CONSENT_WORKFLOWS',
}
